import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './CheckBox.module.css';

// https://www.figma.com/file/hTeMNwZft7zNxdUwanR3ss/%E2%9D%96-Web-Component-Library?node-id=16%3A673
const CheckBox = ({
  children,
  variant = 'blue',
  hasError = false,
  hasFocus = false,
  ...props
}) => {
  return (
    <label
      styleName={classNames('checkbox', {
        [`variant-${variant}`]: variant,
        error: hasError,
        focus: hasFocus
      })}
    >
      {children}
      <input type="checkbox" {...props} />
      <span styleName="checkmark" />
    </label>
  );
};

CheckBox.propTypes = {
  variant: PropTypes.oneOf(['grey', 'blue']),
  hasError: PropTypes.bool,
  hasFocus: PropTypes.bool // trigger focus / hover styles manually
};

export default CheckBox;
